import styled, { keyframes } from 'styled-components';
import theme from '../../styles/theme';
import { Link } from 'gatsby';
import Image from 'gatsby-image';
import ImageTitleBG from '../../images/jpg/title_bg.jpg';
import ImagePinkBG from '../../images/jpg/bg-pink.jpg';
import ImagePalomaBG from '../../images/jpg/bg-paloma.jpg';

const KeyframeArrow = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`;

const StyledInfo = styled.div`
  /* padding: 3rem;
  display: grid;
  grid-template-columns: 1fr 2fr;
  max-width: ${theme.overWidth}; */


  &:nth-child(2) {
    background-repeat: repeat-y;
    background-size: 100%;
    background-image: ${'url(' + ImagePalomaBG + ')'}
  }


  &:nth-child(4) {
    background-repeat: repeat-y;
    background-size: 100%;
    background-image: ${'url(' + ImagePinkBG + ')'}

  }


  .paloma-bg {
    background-image: ${'url(' + ImagePalomaBG + ')'}
  }


  .pink-bg {
    background-image: ${'url(' + ImagePinkBG + ')'}
  }

  margin-left: auto;
  margin-right: auto;
  align-items: flex-start;
  /* grid-gap: 4rem; */
  @media(max-width: 600px){
    padding: 1rem;
    grid-gap: 1rem;
    grid-template-columns: 1fr 2fr;
  }
  .title{

    font-size: 10rem;
    line-height: 10rem;
    font-weight: normal;
    margin: 0 0;
    flex: 0;
    @media(max-width: 1200px){
      font-size: 8rem;
      line-height: 8rem;
    }
    @media(max-width: 800px){
      font-size: 7rem;
      line-height: 7rem;
    }
    @media(max-width: 600px){
      font-size: 4.2rem;
      line-height: 4.2rem;
    }
  }
  .subtitle {
    font-size: 4rem;
    line-height: 4rem;
    margin: 0;
    @media(max-width: 1200px){
      font-size: 3.5rem;
      line-height: 3.5rem;
    }
    @media(max-width: 800px){
      font-size: 3.5rem;
      line-height: 3.5rem;
    }
    @media(max-width: 600px){
      font-size: 2rem;
      line-height: 2rem;
    }
  }
  .info {
    font-size: 1.2rem;
    line-height: 1.2rem;
    margin-block-start: 1rem;
    margin-block-end: 1rem;
    strong{
      display: block;
    }
  }
  .col1{
    position: sticky;
    transform: translate3d(0, 0, 0);
    top: 6rem;
    @media(max-width: 800px){
      top: 4rem;
    }
  }
  .col2{
    .wrap {
      padding-top: 80vh;
      padding-bottom: 40vh;
    }
  }
  .backbutton{
    grid-column: 1 / -1;
    display: block;
    max-width: 260px;
    margin-left: auto;
    margin-right: auto;
    background-color: ${theme.accent};
    color: white;
    text-align: center;
    padding: 2rem 2.5rem;
  }
`;

const Container = styled.section`
	position: relative;
	min-height: 80vh;
	margin-left: auto;
	margin-right: auto;
	.share-wrap {
		display: flex;
		justify-content: center;
		padding: 1rem 0;
	}
`;

const HeroContainer = styled.div`
	position: relative;
	max-height: 100vh;
	display: flex;
	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 2;
		padding: 1rem;
		display: flex;
		align-items: flex-end;
		justify-content: flex-start;
	}
	.wrap {
		overflow: hidden;
	}
	.more {
		position: absolute;
		bottom: 0;
		text-transform: uppercase;
		font-size: 10px;
		text-align: center;
		letter-spacing: 1px;
		padding: 4rem;
		left: 0;
		right: 0;
		font-family: ${theme.fonttitle};
		.icon {
			display: block;
			margin: 12px auto 0;
			animation: ${KeyframeArrow} 1.5s ease-in-out 0s infinite;
		}
	}
`;

const TitleContainer = styled.section`
  position: relative;
  background-color: ${theme.background};
  margin-block-start: ${theme.fonttitlesize};
  margin-block-end: ${theme.fonttitlesize};
  max-width: ${theme.maxWidth};
  margin-left: auto;
  margin-right: auto;
  padding: 1px 1rem;
  @media (max-width: 800px){
    margin-block-start: calc(${theme.fonttitlesize} / 2);
    margin-block-end: calc(${theme.fonttitlesize} / 2);
  }
  h2{
 
    font-size: ${theme.fonttitlesize};
    font-weight: normal;
    line-height: ${theme.fonttitlesize};
    text-transform: uppercase;

    margin: 0;
    @media (max-width: 800px){
      font-size: calc(${theme.fonttitlesize} / 2);
      line-height: 100%;
    }
    small{
      display: block;
      color: ${theme.color};
      /* text-transform: none; */
      /* color: ${theme.color};
      font-family: ${theme.fonttitle3};
      font-style: italic;
      font-weight: normal; */
    }

   


    
  }
  .share-wrap{
    display: flex;
    justify-content: center;
  }
  .excerpt{
    p{
      font-family: ${theme.fonttitle2};
      font-size: calc(${theme.fonttitlesize} / 3);
    }
  }
`;

const StyledImage = styled(Image)`
  width: 100vw;
  height: 100vh;
`;

const StyledContent = styled.div`
	h2 {
		position: relative;
		&:first-child {
			margin-top: 15vh;
		}

		&:after {
			background-image: ${'url(' + ImageTitleBG + ')'};
			background-size: 100%;
			background-repeat: no-repeat;
			background-position: center top;
			margin-left: 0;
			margin-right: 0;
			content: "";
			z-index: -1;
			position: absolute;
			height: 90vh;
			left: 0;
			right: 0;
			top: -50%;
		}
	}
	h2,
	h3,
	p {
		max-width: ${theme.normalWidth};
		margin-left: auto;
		margin-right: auto;
		line-height: ${theme.lineheight};
		margin-block-start: calc(${theme.fontsize} * 1.5);
		margin-block-end: calc(${theme.fontsize} * 1.5);
		padding: 0 1rem;
	}
	h2,
	h3 {
		font-family: ${theme.fonttitle2};
		line-height: 1.1;
		text-align: center;
	}
	p,
	ul li,
	ol {
		font-size: 1.5rem;
		line-height: 1.42857;
		&.has-drop-cap {
			&:first-letter {
				float: left;
				font-family: ${theme.fonttitle};
				color: ${theme.accent};
				font-size: 6.2rem;
				line-height: 5.2rem;
				padding-top: 4px;
				padding-right: 8px;
				padding-left: 3px;
			}
		}
	}
	li {
		margin-block-end: 1rem;
	}
	ul {
		margin-block-end: 1rem;
	}
`;

const Button = styled.div`
	transition: all 300ms ease-out;
	font-size: 2rem;
	width: auto;
	display: block;
	max-width: 150px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${theme.accent};
	border: 3px solid;
	border-color: ${theme.accent};
	margin-left: auto;
	margin-right: auto;
	padding: 0.5rem;
	margin-block-start: 1rem;
	margin-block-end: 1rem;
	span {
		font-size: 1rem;
		padding-right: 1rem;
	}
	&:hover,
	&:active {
		color: ${theme.color};
		background-color: ${theme.accent};
	}
`;

const Col = styled.div`
	display: grid;
	grid-template-columns: 1fr 5rem;
	align-items: center;
	grid-gap: 10px;
`;

export { Container, TitleContainer, StyledContent, StyledImage, HeroContainer, Col, StyledLink, Button, StyledInfo };
